export default class RenderWasm {
	_videoEditor = null
	constructor(canvasId) {}

	// 播放
	play() {
		Module.ccall('media_editor_play', 'number', ['number'], [this._videoEditor])
	}

	// 暂停
	pause() {
		Module.ccall('media_editor_pause', 'number', ['number'], [this._videoEditor])
	}

	// 构建视频编辑器
	createVideoEditor(canvasId, width, height) {
		// 6/21 改动，添加了 width 和 height 两个参数，该函数调用后，内部会将 canvas 的 width 和 height 修改为传入值（不会动 CSS）
		this._videoEditor = Module.ccall(
			'create_video_editor',
			'number',
			['string', 'number', 'number'],
			[canvasId, width, height]
		)
	}

	// 销毁canvas
	destoryVideoEditor() {
		window.alert('销毁视频编辑器')
		this._videoEditor = Module.ccall(
			'destory_video_editor',
			'number',
			['number'],
			[this._videoEditor]
		)
	}

	/**
	 * 创建 Card 以 name 为唯一标识
	 * @param card_name
	 * @param duration
	 * @constructor
	 */
	addCard(card_name, duration) {
		Module.ccall(
			'add_card',
			'number',
			['number', 'string', 'number'],
			[this._videoEditor, card_name, duration]
		)
	}

	/**
	 * 修改 Card 时长
	 * @param card_name
	 * @param duration
	 * @constructor
	 */
	updateCardDuration(card_name, duration) {
		Module.ccall(
			'update_card_duration',
			'number',
			['number', 'string', 'number'],
			[this._videoEditor, card_name, duration]
		)
	}

	/**
	 * 中文转义为unicode 改函数为工具函数，非接口
	 * 注：传入c++层的中文，需要用该函数做转义
	 * @param chineseStr
	 * @returns {string}
	 */
	toUnicode(chineseStr) {
		if (chineseStr == '') {
			return ''
		}
		let unicodeStr = ''
		for (let i = 0, iLength = chineseStr.length; i < iLength; i++) {
			unicodeStr += '\\u' + chineseStr.charCodeAt(i).toString(16)
		}
		return unicodeStr
	}

	/**
	 * 创建文字clip
	 * @param card_name
	 * @param clip_name
	 * @param font_uuid 字体路径的唯一标识
	 * @param font_path 字体路径（https路径）
	 * @param text 文字内容
	 * @param size 文字大小
	 * @constructor
	 */
	addTextClip(card_name, clip_name, font_uuid, font_path, text, size, sequenceIn, sequenceOut) {
		Module.ccall(
			'add_text_clip',
			'number',
			['number', 'string', 'string', 'string', 'string', 'string', 'number'],
			[this._videoEditor, card_name, clip_name, font_uuid, font_path, toUnicode(text), size]
		)

		Module.ccall(
			'update_clip_sequence',
			'number',
			['number', 'string', 'number', 'number'],
			[this._videoEditor, clip_name, sequenceIn, sequenceOut]
		)
	}

	/**
	 *
	 * @param card_name 所属card名称
	 * @param clip_name clip名称
	 * @param res_uuid  图片路径唯一标识
	 * @param file_path 图片路径（https）
	 * @constructor
	 */
	addImageClip(card_name, clip_name, res_uuid, file_path, sequenceIn, sequenceOut) {
		Module.ccall(
			'add_image_clip',
			'number',
			['number', 'string', 'string', 'string', 'string'],
			[this._videoEditor, card_name, clip_name, res_uuid, file_path]
		)

		Module.ccall(
			'update_clip_sequence',
			'number',
			['number', 'string', 'number', 'number'],
			[this._videoEditor, clip_name, sequenceIn, sequenceOut]
		)
	}

	/**
	 *
	 * @param card_name
	 * @param clip_name
	 * @param res_uuid  音视频路径唯一标识
	 * @param file_path 视频/音频文件路径 （在m3u8做好之前，需要用之前的fetch方式下载下来，然后传入原先的根目录路径）
	 * @param sequenceIn   在card上的开始时间
	 * @param sequenceOut  在card上的结束时间
	 * @param trimIn      文件自身开始剪辑时间 （目前没有该功能，待完善）
	 * @param trimOut     文件自身结束剪辑时间 （目前没有该功能，待完善）
	 * @constructor
	 */
	addAvClip(card_name, clip_name, file_path, sequenceIn, sequenceOut) {
		console.log(card_name, clip_name, file_path, sequenceIn, sequenceOut, '=-=')
		const log = Module.ccall(
			'add_av_clip',
			'number',
			['number', 'string', 'string', 'string', 'string'],
			[this._videoEditor, card_name, clip_name, 'res_uuid', file_path]
		)
		console.log(log, '=-=')
		Module.ccall(
			'update_clip_sequence',
			'number',
			['number', 'string', 'number', 'number'],
			[this._videoEditor, clip_name, sequenceIn, sequenceOut]
		)
	}

	/**
	 * 添加数字人Clip
	 * @param card_name
	 * @param clip_name
	 * @param res_uuid  音视频路径唯一标识
	 * @param file_path 视频/音频文件路径 （在m3u8做好之前，需要用之前的fetch方式下载下来，然后传入原先的根目录路径）
	 * @param sequenceIn   在card上的开始时间
	 * @param sequenceOut  在card上的结束时间
	 * @constructor
	 */
	addVirtualManClip(card_name, clip_name, res_uuid, file_path, sequenceIn, sequenceOut) {
		Module.ccall(
			'add_virtual_man_clip',
			'number',
			['number', 'string', 'string', 'string', 'string'],
			[this._videoEditor, card_name, clip_name, res_uuid, file_path]
		)

		Module.ccall(
			'update_clip_sequence',
			'number',
			['number', 'string', 'number', 'number'],
			[this._videoEditor, clip_name, sequenceIn, sequenceOut]
		)
	}

	/**
	 * 根据名字删除clip（三种clip都兼容）
	 * @param clip_name
	 * @constructor
	 */
	removeClip(clip_name) {
		Module.ccall('remove_clip', 'number', ['number', 'string'], [this._videoEditor, clip_name])
	}

	/**
	 * 更新clip的位置
	 * @param clip_name
	 * @param x 坐标系 左上角为原点，向右向下为正方向
	 * @param y
	 * @constructor
	 */

	updateClipPositon(clip_name, x, y) {
		Module.ccall(
			'update_clip_positon',
			'number',
			['number', 'string', 'number', 'number'],
			[this._videoEditor, clip_name, x, y]
		)
	}

	/**
	 * 更新clip缩放信息
	 * @param clip_name
	 * @constructor
	 */
	updateClipScale(clip_name, scaleX, scaleY) {
		Module.ccall(
			'update_clip_scale',
			'number',
			['number', 'string', 'number', 'number'],
			[this._videoEditor, clip_name, scaleX, scaleY]
		)
	}

	/**
	 * 设置clip层级
	 * @param clip_name
	 * @param zIndex  层级，数字越大，层级越靠上
	 * @constructor
	 */
	updateClipZindex(clip_name, zIndex) {
		Module.ccall(
			'update_clip_z_index',
			'number',
			['number', 'string', 'number'],
			[this._videoEditor, clip_name, zIndex]
		)
	}

	// 设置clip播放时间
	_updateClipSequence(clip_name, sequenceIn, sequenceOut) {
		Module.ccall(
			'update_clip_sequence',
			'number',
			['number', 'string', 'number', 'number'],
			[this._videoEditor, clip_name, sequenceIn, sequenceOut]
		)
	}

	// 更新(滤镜/动画)
	updateFilterSequence(filter_name, sequenceIn, sequenceOut) {
		Module.ccall(
			'update_filter_sequence',
			'number',
			['number', 'string', 'number', 'number'],
			[this._videoEditor, filter_name, sequenceIn, sequenceOut]
		)
	}

	/**
	 * 设置clip旋转角度
	 * @param clip_name
	 * @param rotateAngle 角度 0.0 - 360.0
	 * @constructor
	 */
	updateClipRotateAngle(clip_name, rotateAngle) {
		Module.ccall(
			'update_clip_rotate_angle',
			'number',
			['number', 'string', 'number'],
			[this._videoEditor, clip_name, rotateAngle]
		)
	}

	/**
	 * 设置字体大小
	 * @param clip_name
	 * @param size 字体大小
	 * @constructor
	 */
	updateTextFontSize(clip_name, size) {
		Module.ccall(
			'update_text_font_size',
			'number',
			['number', 'string', 'number'],
			[this._videoEditor, clip_name, size]
		)
	}

	/**
	 * 设置字体路径
	 * @param clip_name
	 * @param font_path 字体路径
	 * @constructor
	 */
	updateTextFontPath(clip_name, font_path) {
		Module.ccall(
			'update_text_font_path',
			'number',
			['number', 'string', 'string'],
			[this._videoEditor, clip_name, font_path]
		)
	}

	/**
	 * 设置文字内容
	 * @param clip_name
	 * @param content 文字内容
	 * @constructor
	 */
	updateTextFontContent(clip_name, content) {
		Module.ccall(
			'update_text_font_content',
			'number',
			['number', 'string', 'string'],
			[this._videoEditor, clip_name, toUnicode(content)]
		)
	}

	/**
	 * 设置文字颜色
	 * @param clip_name
	 * @param r 红色色值 【0.0 - 1.0】
	 * @param g 绿色色值 【0.0 - 1.0】
	 * @param b 蓝色色值 【0.0 - 1.0】
	 * @constructor
	 */
	updateTextFontColor(clip_name, r, g, b) {
		Module.ccall(
			'update_text_font_color',
			'number',
			['number', 'string', 'number', 'number', 'number'],
			[this._videoEditor, clip_name, r, g, b]
		)
	}

	/**
	 * 设置文字行间距
	 * @param clip_name
	 * @param line_height 行间距 int类型，单位：px
	 * @constructor
	 */
	updateTextLineHeight(clip_name, line_height) {
		Module.ccall(
			'update_text_line_height',
			'number',
			['number', 'string', 'number'],
			[this._videoEditor, clip_name, line_height]
		)
	}

	/**
	 * 设置对齐方式
	 * @param clip_name
	 * @param align_type 对齐方式 CENTER  LEFT  RIGHT
	 * @constructor
	 */
	updateTextAlignType(clip_name, align_type) {
		Module.ccall(
			'update_text_align_type',
			'number',
			['number', 'string', 'string'],
			[this._videoEditor, clip_name, align_type]
		)
	}

	/**
	 * 设置音频声音
	 * @param clip_name
	 * @param volume 音量范围 【0-1】
	 * @constructor
	 */
	updateAvClipVolume(clip_name, volume) {
		console.log(clip_name, volume)
		Module.ccall(
			'update_av_clip_volume',
			'number',
			['number', 'string', 'number'],
			[this._videoEditor, clip_name, volume]
		)
	}

	/**
	 * 获取clip边框四个角的坐标
	 * @param clip_name
	 * @constructor
	 * TODO
	 */
	getClipBoundingBox(clip_name) {
		let json_c_style = Module.ccall(
			'get_clip_bounding_box',
			'number',
			['number', 'string'],
			[this._videoEditor, clip_name]
		)
		let json = Module.UTF8ToString(json_c_style)
		Module._free(json_c_style)
		let parsedData
		try {
			parsedData = JSON.parse(json)
			// 处理解析后的数据
		} catch (error) {
			console.log('JSON parse error:', error)
		}
		return parsedData
	}

	/**
	 * 获取点在card上最上层clipname
	 * @param card_name
	 * @param x x轴坐标
	 * @param y y轴坐标
	 * @param time 在timeline上的时间点,单位秒
	 * 如果返回"card not found"，代表card不存在
	 * TODO
	 */
	getTopClipName(card_name, x, y, time) {
		let clip_name_cstyle = Module.ccall(
			'get_top_clip_name',
			'number',
			['number', 'string', 'number', 'number', 'number'],
			[this._videoEditor, card_name, x, y, time]
		)
		let clip_name = Module.UTF8ToString(clip_name_cstyle)
		Module._free(clip_name_cstyle)
	}

	/**
	 * clip是否存在，0，存在; -1，不存在
	 * @param clip_name
	 * @constructor
	 * TODO
	 */
	existClip(clip_name) {
		let ret = Module.ccall(
			'exist_clip',
			'number',
			['number', 'string'],
			[this._videoEditor, clip_name]
		)
	}

	/**
	 * 添加 filter(滤镜)
	 *
	 * @param filter_name 滤镜名称
	 * @param clip_name   片段名称
	 * @param filter_type 滤镜类型
	 * @param sequenceIn   滤镜在clip上的开始时间
	 * @param sequenceOut  滤镜在clip上的结束时间
	 * type:
	 * ALPHA_GRADIENT(1, "ALPHA_GRADIENT");            淡入
	 * ALPHA_FADEOUT(2, "ALPHA_FADEOUT");              淡出
	 * SOUL_OUT(3, "SOUL_OUT");                        放大突散
	 */
	// addFilter(clip_name, filter_name, filter_type, filter_mode, sequenceIn, sequenceOut) {
	// 	Module.ccall(
	// 		'add_filter',
	// 		'number',
	// 		['number', 'string', 'string', 'string'],
	// 		[this._videoEditor, filter_name, clip_name, filter_type]
	// 	)

	// 	Module.ccall(
	// 		'update_filter_sequence',
	// 		'number',
	// 		['number', 'string', 'number', 'number'],
	// 		[this._videoEditor, filter_name, sequenceIn, sequenceOut]
	// 	)
	// 	if (filter_type === 'FLY_IN') {
	// 		this.setFilterMode(filter_name, filter_mode)
	// 	}
	// }

	addFilter(filter_name, clip_name, filter_type, sequenceIn, sequenceOut) {
		if (
			filter_name === undefined ||
			clip_name === undefined ||
			filter_type === undefined ||
			sequenceIn === undefined ||
			sequenceOut === undefined
		) {
			console.error('Exists undefined value!')
			return
		}

		if (sequenceOut <= sequenceIn) {
			console.error('Invalid filter sequenceIn/sequenceOut time!')
			return
		}
		let ret = Module.ccall(
			'add_filter',
			'number',
			['number', 'string', 'string', 'string'],
			[this._videoEditor, filter_name, clip_name, filter_type]
		)

		if (0 != ret) {
			console.error('addFilter failed: ' + filter_type)
			return
		}

		ret = Module.ccall(
			'update_filter_sequence',
			'number',
			['number', 'string', 'number', 'number'],
			[this._videoEditor, filter_name, sequenceIn, sequenceOut]
		)
		if (0 != ret) {
			console.error('update_filter_sequence failed: ' + filter_name)
			return
		}
	}

	/**
	 * 添加转场
	 * @param transition_name 转场id
	 * @param a_clip_id       第一个卡片Id
	 * @param b_clip_id       第二个卡片Id
	 * @param transition_type 转场类型，可选类型如下：
	 * CROSS_DISSOLVE       (2, "CROSS_DISSOLVE");   淡入淡出
	 * MOVE_AROUND          (3, "MOVE_AROUND");      上下左右移入，配合SetTransitionMode使用
	 * @constructor
	 */
	addTransition(transition_name, a_clip_id, b_clip_id, transition_type) {
		Module.ccall(
			'media_editor_add_transition',
			'number',
			['number', 'string', 'string', 'string', 'string'],
			[this._videoEditor, transition_name, a_clip_id, b_clip_id, transition_type]
		)
	}

	// 更新转场时长
	updateTransitionDuration(transition_name, a_clip_duration, b_clip_duration) {
		Module.ccall(
			'media_editor_update_transiton_duration',
			'number',
			['number', 'string', 'number', 'number'],
			[this._videoEditor, transition_name, a_clip_duration, b_clip_duration]
		)
	}

	/**
	 * 设置转场方向
	 * 0， 从上往下
	 * 1， 从下往上
	 * 2， 从右往左
	 * 3， 从左往右
	 * @param transition_name
	 * @param mode
	 * @constructor
	 */
	setTransitionMode(transition_name, mode) {
		Module.ccall(
			'media_editor_set_transiton_mode',
			'number',
			['number', 'string', 'number'],
			[this._videoEditor, transition_name, mode]
		)
	}

	/**
	 * 设置filter方向
	 * 0， 从下飞入
	 * 1， 从上飞入
	 * 2， 从右飞入
	 * 3， 从左飞入
	 * 4， 从上飞出
	 * 5， 从下飞出
	 * 6， 从左飞出
	 * 7， 从右飞出
	 * @param filter_name
	 * @param mode
	 * @constructor
	 */
	setFilterMode(filter_name, mode) {
		Module.ccall(
			'set_filter_mode',
			'number',
			['number', 'string', 'number'],
			[this._videoEditor, filter_name, mode]
		)
	}

	/**
	 * 删除card
	 * @param card_name
	 * @constructor
	 */
	removeCard(card_name) {
		Module.ccall('remove_card', 'number', ['number', 'string'], [this._videoEditor, card_name])
	}

	/**
	 * 删除片段
	 *
	 * @param clip_name 片段名称
	 * @constructor
	 */
	removeClip(clip_name) {
		Module.ccall('remove_clip', 'number', ['number', 'string'], [this._videoEditor, clip_name])
	}

	/**
	 * 删除滤镜
	 *
	 * @param filter_name 滤镜名称
	 * @constructor
	 */
	removeFilter(filter_name) {
		Module.ccall('remove_filter', 'number', ['number', 'string'], [this._videoEditor, filter_name])
	}

	/**
	 * 删除转场
	 *
	 * @param transition_name 转场名称
	 * @constructor
	 */
	removeTransition(transition_name) {
		Module.ccall(
			'remove_transition',
			'number',
			['number', 'string'],
			[this._videoEditor, transition_name]
		)
	}

	/**
	 * 将当前时间线序列化为json
	 *
	 * @constructor
	 */
	_serializableJson() {
		let json_c_style = Module.ccall('serializable_json', 'number', ['number'], [this._videoEditor])

		let json = Module.UTF8ToString(json_c_style)
		Module._free(json_c_style)
		return JSON.parse(json)
	}

	/**
	 * 将json 反序列化为 时间线
	 *
	 * @param json
	 * @constructor
	 */
	parseJson(json) {
		var ptr = Module.allocate(intArrayFromString(json), 0)

		Module.ccall('parse_json', 'number', ['number', 'number'], [this._videoEditor, ptr])
		Module._free(ptr)
	}

	parseJsonNetwork(url) {
		let xhr = new XMLHttpRequest()
		xhr.responseType = 'json'
		xhr.open('GET', url)
		xhr.send()
		xhr.onreadystatechange = function () {
			if (xhr.readyState == 4 && xhr.status == 200) {
				let jsonStr = JSON.stringify(xhr.response)
				var ptr = Module.allocate(intArrayFromString(jsonStr), 0)
				Module.ccall('parse_json', 'number', ['number', 'number'], [this._videoEditor, ptr])

				Module._free(ptr)
			}
		}
	}

	/**
	 * 获取SDK版本号
	 * @constructor
	 */
	getVersion() {
		let version_c_style = Module.ccall('get_version', 'number', ['number'], [this._videoEditor])
		let version = Module.UTF8ToString(version_c_style)
		console.log(version)
		Module._free(version_c_style)
	}

	/**
	 * 打印SDK日志
	 * @param ifPrint  1：打印   0： 不打印  默认值为1
	 * @constructor
	 */
	printSdkLog(ifPrint) {
		Module.ccall('print_sdk_log', 'number', ['number'], [ifPrint])
	}

	/**
	 * 根据clip_name，获取clip信息，返回json
	 * @param clip_name
	 * @constructor
	 */
	getClipByName(clip_name) {
		let json_c_style = Module.ccall(
			'get_clip_by_name',
			'number',
			['number', 'string'],
			[this._videoEditor, clip_name]
		)
		let json = Module.UTF8ToString(json_c_style)
		Module._free(json_c_style)
		return JSON.parse(json)
	}

	// 获取当前播放时间
	getCurrentPlayTime() {
		let currentTime = Module.ccall(
			'get_current_play_time',
			'number',
			['number'],
			[this._videoEditor]
		)
		return currentTime
	}

	// 根据点进行渲染
	seek(time) {
		console.log('seek', time)
		Module.ccall('seek', 'number', ['number', 'number'], [this._videoEditor, time])
	}

	writeArraybufferToMemfs(bufferName, int8a) {
		let len = int8a.length * int8a.BYTES_PER_ELEMENT
		let ptr = Module._malloc(len)
		Module.HEAPU8.set(int8a, ptr)
		Module.ccall(
			'write_arraybuffer_to_memfs',
			'number',
			['number', 'number', 'string'],
			[ptr, len, `/${bufferName}`]
		)
		Module._free(ptr)
	}
	// 设置描边大小
	updateTextFontStrokeSize(clip_name, size) {
		if (clip_name === undefined || size === undefined) {
			console.error('Exists undefined value!')
			return
		}

		let ret = Module.ccall(
			'update_text_font_stroke_size',
			'number',
			['number', 'string', 'number'],
			[this._videoEditor, clip_name, size]
		)
		if (-1 == ret) {
			console.error(
				'update_text_font_stroke_size failed: ' +
					clip_name +
					',can not find clip or update text stroke size failed.'
			)
		} else if (-2 == ret) {
			console.error('update_text_font_stroke_size failed: ' + clip_name + ',clip is not text clip.')
		}
	}

	/**
     * 设置描边颜色
     * @param clip_name

     * @param r 红色色值 【0.0 - 1.0】
     * @param g 绿色色值 【0.0 - 1.0】
     * @param b 蓝色色值 【0.0 - 1.0】
     * @constructor
     */
	updateTextFontStrokeColor(clip_name, r, g, b) {
		if (clip_name === undefined || r === undefined || g === undefined || b === undefined) {
			console.error('Exists undefined value!')
			return
		}

		let ret = Module.ccall(
			'update_text_font_stroke_color',
			'number',
			['number', 'string', 'number', 'number', 'number'],
			[this._videoEditor, clip_name, r, g, b]
		)
		if (-1 == ret) {
			console.error(
				'update_text_font_stroke_color failed: ' +
					clip_name +
					',can not find clip or update text stroke color failed.'
			)
		} else if (-2 == ret) {
			console.error(
				'update_text_font_stroke_color failed: ' + clip_name + ',clip is not text clip.'
			)
		}
	}

	/**
	 * 设置在原视频截取的开始时间和结束时间
	 * @param trimIn 原视频上的开始时间
	 * @param trimOut 原视频上的结束时间
	 * @constructor
	 */
	updateTrimInfo(clip_name, trimIn, trimOut) {
		if (clip_name === undefined || trimIn === undefined || trimOut === undefined) {
			console.error('Exists undefined value!')
			return
		}

		let ret = Module.ccall(
			'update_clip_trim',
			'number',
			['number', 'string', 'number', 'number'],
			[this._videoEditor, clip_name, trimIn, trimOut]
		)
		if (0 != ret) {
			console.error('update_clip_trim failed: ' + clip_name)
		}
	}

	updateBackgroundColor(r, g, b) {
		if (r === undefined || g === undefined || b === undefined) {
			console.error('Exists undefined value!')
			return
		}

		let ret = Module.ccall(
			'update_background_color',
			'number',
			['number', 'number', 'number', 'number'],
			[this._videoEditor, r, g, b]
		)
		if (ret != 0) {
			console.error('update_background_color failed!')
		}
	}

	/**
	 * 修改videoEditor对象宽高
	 * @param width
	 * @param height
	 * @returns {number}
	 * @constructor
	 */
	setVideoEditorWH(canvasId, width, height) {
		if (canvasId === undefined || width === undefined || height === undefined) {
			console.error('Exists undefined value!')
			return -1
		}
		if (0 != width && 0 != height) {
			let ret = Module.ccall(
				'set_video_editor_wh',
				'number',
				['number', 'string', 'number', 'number'],
				[this._videoEditor, canvasId, width, height]
			)
			return ret
		} else {
			console.error('width or height == 0!')
			return -2
		}
	}

	/**
	 * 添加 ScaleX关键帧
	 * @param clip_name
	 * @param time clip时间戳
	 * @param scaleX x轴缩放大小
	 * @constructor
	 */
	addClipScaleXTween(clip_name, time, scaleX) {
		if (clip_name === undefined || time === undefined || scaleX === undefined) {
			console.error('Exists undefined value!')
			return
		}

		let ret = Module.ccall(
			'add_clip_scale_x_tween',
			'number',
			['number', 'string', 'number', 'number'],
			[this._videoEditor, clip_name, time, scaleX]
		)
		if (0 != ret) {
			console.error('add_clip_scale_x_tween failed: ' + clip_name)
		}
	}

	/**
	 * 添加 ScaleY关键帧
	 * @param clip_name
	 * @param time clip时间戳
	 * @param scaleY x轴缩放大小
	 * @constructor
	 */
	addClipScaleYTween(clip_name, time, scaleY) {
		if (clip_name === undefined || time === undefined || scaleY === undefined) {
			console.error('Exists undefined value!')
			return
		}

		let ret = Module.ccall(
			'add_clip_scale_y_tween',
			'number',
			['number', 'string', 'number', 'number'],
			[this._videoEditor, clip_name, time, scaleY]
		)
		if (0 != ret) {
			console.error('add_clip_scale_y_tween failed: ' + clip_name)
		}
	}

	/**
	 * 添加clip x方向关键帧
	 * @param clip_name
	 * @param time clip时间戳
	 * @param x x方向的值
	 * @constructor
	 */
	addClipPositionXTween(clip_name, time, x) {
		if (clip_name === undefined || time === undefined || x === undefined) {
			console.error('Exists undefined value!')
			return
		}

		let ret = Module.ccall(
			'add_clip_position_x_tween',
			'number',
			['number', 'string', 'number', 'number'],
			[this._videoEditor, clip_name, time, x]
		)
		if (0 != ret) {
			console.error('add_clip_position_x_tween failed: ' + clip_name)
		}
	}

	/**
	 * 添加clip y方向关键帧
	 * @param clip_name
	 * @param time clip时间戳
	 * @param y y方向的值
	 * @constructor
	 */
	addClipPositionYTween(clip_name, time, y) {
		if (clip_name === undefined || time === undefined || y === undefined) {
			console.error('Exists undefined value!')
			return
		}

		let ret = Module.ccall(
			'add_clip_position_y_tween',
			'number',
			['number', 'string', 'number', 'number'],
			[this._videoEditor, clip_name, time, y]
		)
		if (0 != ret) {
			console.error('add_clip_position_y_tween failed: ' + clip_name)
		}
	}

	/**
	 * 根据类型，删除该类型所有关键帧
	 * @param clip_name
	 * @param type 4种类型："X"，"Y"，"SCALE_X"，"SCALE_Y"
	 * @constructor
	 */
	removeClipTween(clip_name, type) {
		if (clip_name === undefined || type === undefined) {
			console.error('Exists undefined value!')
			return
		}

		let ret = Module.ccall(
			'remove_clip_tween',
			'number',
			['number', 'string', 'string'],
			[this._videoEditor, clip_name, type]
		)
		if (0 != ret) {
			console.error('remove_clip_tween failed: ' + clip_name)
		}
	}
}

function toUnicode(chineseStr) {
	if (chineseStr == '') {
		return ''
	}
	let unicodeStr = ''
	for (let i = 0, iLength = chineseStr.length; i < iLength; i++) {
		unicodeStr += '\\u' + chineseStr.charCodeAt(i).toString(16)
	}
	return unicodeStr
}

/**
 * 获取文字初始宽高
 * @param clip_name
 * @constructor
 */
function GetTextClipWH(clip_name) {
	if (clip_name === undefined) {
		console.error('Exists undefined value!')
		return
	}

	let event = Module.ccall(
		'create_get_text_clip_wh_event',
		'number',
		['number', 'string'],
		[this._videoEditor, clip_name]
	)

	let width = Module.ccall('get_text_clip_width', 'number', ['number'], [event])
	let height = Module.ccall('get_text_clip_height', 'number', ['number'], [event])

	console.debug('width: ', width, ' height: ', height)

	Module.ccall('destory_get_text_clip_wh_event', 'number', ['number'], [event])
}
